import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleOAuth from "./GoogleOAuth";

const GoogleButton = () => {
  return (
    <GoogleOAuthProvider
      clientId={
        "1001539542292-cclc6p3efsq4lqs9omlbqss33649fb05.apps.googleusercontent.com"
      }
    >
      <GoogleOAuth />
    </GoogleOAuthProvider>
  );
};

export default GoogleButton;
